import React from 'react';
import { BreakpointsOfTOrT } from '../../theme';
import { useBreakpointMap } from '../../utils/useBreakpointMap';
import { Table } from './Table';
import { CompactTable } from './CompactTable';
import { TableType, TableSize } from './types';

export type ResponsiveTableProps = TableType & {
  size?: BreakpointsOfTOrT<TableSize>;
};

const defaultSize: BreakpointsOfTOrT<TableSize> = {
  xs: 'small',
  md: 'large',
};

export const ResponsiveTable: React.FC<ResponsiveTableProps> = ({
  size = defaultSize,
  ...props
}) => {
  const mappedSize = useBreakpointMap(size);

  return mappedSize === 'large' ? (
    <Table {...props} />
  ) : (
    <CompactTable {...props} />
  );
};
